import {
  GetAllTotPermitTransactionsQuery,
  Period,
  DiscrepancyStatus as ServerDiscrepancyStatus,
  InterestStatus as ServerInterestStatus,
  PenaltyStatus as ServerPenaltyStatus,
  ReportingStatus as ServerReportingStatus,
  TaxItemOrder,
} from '@/api/ariadne/__generated_types__/apollo';

// Converts an enum to a union of string literals of the enum values
type EnumValueUnion<T extends Record<string, string>> = `${T[keyof T]}`;

export type LicensePayment =
  GetAllTotPermitTransactionsQuery['region']['taxItems']['edges'][number]['node'];

export type BooleanDict = Record<string, boolean>;

// By default "Period" allows the values to be of any type, this narrows the values to be strings
export type PaymentPeriodDateRange = Record<keyof Period, string>;

export enum ReportingPeriod {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export interface QueryFilters {
  reportingStatus: ServerReportingStatus[];
  interest: ServerInterestStatus[];
  penalties: ServerPenaltyStatus[];
  discrepancy: ServerDiscrepancyStatus[];
  removeZeroTaxableReceipts: boolean;
}

export type ReportingStatus = EnumValueUnion<typeof ServerReportingStatus>;
export type Penalties = EnumValueUnion<typeof ServerPenaltyStatus>;
export type Interest = EnumValueUnion<typeof ServerInterestStatus>;
export type Auditing = 'POTENTIAL_TAX_DISCREPANCY';

export interface TopLevelTOTFilters {
  removeZeroTaxableReceipts: boolean;
  reportingStatus: ReportingStatus[];
  penalties: Penalties[];
  interest: Interest[];
  auditing?: Auditing[];
}

export type SortMode = EnumValueUnion<typeof TaxItemOrder>;

export type SortMappings = {
  // "field" matches the "field" defined per column (refer to "createDefaultTOTColumns")
  [field: string]: {
    // The below consolidates sort modes keywords to the respective sort mode
    asc: Extract<SortMode, `${string}_ASC`>;
    desc: Extract<SortMode, `${string}_DESC`>;
  };
};

type FilterConfig = {
  groupName: string;
  filters: string[];
};

export type FilterConfigs = FilterConfig[];

export type RSuiteWhisperSpeakerRenderFn = (
  style: Record<string, string | number | undefined>,
  ref: (instance: HTMLElement | null) => void,
  className: string,
  onClose?: (delay?: number) => NodeJS.Timeout | void
) => JSX.Element;
